var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500,10C229.4,10,10,229.4,10,500c0,270.6,219.4,490,490,490c270.6,0,490-219.4,490-490C990,229.4,770.6,10,500,10L500,10z M500,928.8C263.6,928.8,71.2,736.4,71.2,500C71.2,263.6,263.6,71.2,500,71.2c236.4,0,428.7,192.3,428.7,428.8C928.8,736.4,736.4,928.8,500,928.8L500,928.8z M500,377.5c-33.8,0-61.3,27.4-61.3,61.2V745c0,33.8,27.4,61.3,61.3,61.3c33.8,0,61.2-27.4,61.2-61.3V438.7C561.3,404.9,533.8,377.5,500,377.5L500,377.5z M438.7,256c0-16,6.6-32,17.9-43.3c11.3-11.3,27.3-17.9,43.3-17.9c16,0,32,6.6,43.3,17.9c11.3,11.3,17.9,27.3,17.9,43.3c0,16-6.6,32-17.9,43.3C532,310.6,516,317.2,500,317.2c-16,0-32-6.6-43.3-17.9C445.4,287.9,438.7,272,438.7,256L438.7,256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6826c40f.svg";
export { ForwardRef as ReactComponent };